import { AdminRouteName } from '../../../CONSTANTS';
import RentCollectionTableRecords from '../RentCollectionTableRecords';

const AwaitingRentCollection = () => (
  <RentCollectionTableRecords defaultUrl={AdminRouteName.rentCollectionAwaitingSettlement} toggleStorageId="awaiting_rent-collection-table-col" hasNameAndImage permissionName="can-view-rent-payment" tabStatus="UNSETTLED" />
);
export default AwaitingRentCollection;
